export default __webpack_public_path__ + "static/media/GEL.07183568.png";